module.exports = __webpack_public_path__ + "static/img/fish25.80c235c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish25.png
// module id = 3X0e
// module chunks = 0